import { defineComponent as _defineComponent } from 'vue'
import { useContext, useRoute, computed } from '@nuxtjs/composition-api';
import { useTwoRowHeader } from '~/composables/useTwoRowHeader';

interface Props {
  icon: string;
  title: string;
  url: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuItem',
  props: {
    icon: null,
    title: null,
    url: null
  },
  setup(__props: any) {

const props = __props as {
  icon: string;
  title: string;
  url: string;
};

const { localePath } = useContext();
const currentRoute = useRoute();
const { navigationUserClickedEvent } = useTwoRowHeader();



const isActive = computed(() => {
  return currentRoute?.value?.fullPath?.includes(props.url);
});

const trackClick = () => {
  navigationUserClickedEvent('Ribbon', props.title, props.url);
};

return { __sfc: true,localePath, currentRoute, navigationUserClickedEvent, props, isActive, trackClick }
}

})